angular.module('rjmNg.api').factory("AggregateDefinition", [
  'BaseDefinition'
  'referenceService'
  'utils'
  (BaseDefinition, referenceService, utils) ->

    class AggregateDefinition extends BaseDefinition

      @definition: 'aggregate'
      @category: 'manyToOne'
      @arg: 'tableColumn'
      @subtypes: [
          symbol: 'AVG'
          subtype: 'average'
          description: 'The average of all matching values.'
          typeFilter: [
            'int'
            'decimal'
            'float'
          ]
        ,
          symbol: 'COUNT'
          subtype: 'count'
          description: 'The total number of matching rows.'
          arg: 'table'
        ,
          symbol: 'COUNT_DISTINCT'
          subtype: 'count_distinct'
          description: 'The total number of distinct matching values.'
        ,
          symbol: 'EXISTS'
          subtype: 'exists'
          description: 'Indicates whether there are rows in a table which match the specified filter. Expressed as a 1 if yes, and 0 if no.'
          arg: 'table'
        ,
          symbol: 'MAX'
          subtype: 'max'
          description: 'The maximum matching value.'
          typeFilter: [
            'int'
            'decimal'
            'inst'
            'string'
            'float'
          ]
        ,
          symbol: 'MIN'
          subtype: 'min'
          description: 'The minimum matching value.'
          typeFilter: [
            'int'
            'decimal'
            'inst'
            'string'
            'float'
          ]
        ,
          symbol: 'SUM'
          subtype: 'sum'
          description: 'The sum of matching values.'
          typeFilter: [
            'int'
            'decimal'
            'float'
          ]
      ]
      @filtersSupported: true

      @fromColumn: (structure, column, references) ->

        if not @subtypes.some((subtype) -> subtype.subtype is column.properties.aggregate_operation)
          throw "Unable to convert column; unsupported aggregate operation (#{field.subtype})"

        field = super structure, column, @definition

        columnId = column.properties.operand_column_id
        tableId = structure.columns[columnId].table_id

        field.subtype = column.properties.aggregate_operation
        field.attrs.ref.column = columnId
        field.attrs.ref.table = tableId
        referenceList = referenceService.find(references, column)

        localKeyId = column.properties.joins[0].local_column_ids[0]
        foreignKeyId = column.properties.joins[0].foreign_column_ids[0]

        for reference in referenceList
          if localKeyId is reference.to.column and foreignKeyId is reference.from.column
            field.attrs.reference = reference
            break

        return field

      @getColumnForField: (structure, tableId, foreignColumnId, field) ->
        arg = @getArg(field.subtype)

        if arg is 'column' or arg is 'tableColumn'
          return structure.columns[field.attrs.ref.column]
        else if arg is 'table'
          return structure.columns[foreignColumnId]
        else
          throw "Invalid aggregate operand type (#{arg})"

      @nonDataTypeChange: (originalColumn, resultingColumn) ->
        _.isEqual(_.omit(originalColumn.properties, 'filter_set'),
                  _.omit(resultingColumn.properties, 'filter_set'))

      @toColumn: (structure, table, field) ->
        # Make sure this reference is pointing the right way for this table
        reference = field.attrs.reference

        arg = @getArg(field.subtype)

        # This makes sure we use the correct direction for the reference
        localColumnId = reference.getLocalColumnId(table)
        foreignColumnId = reference.getForeignColumnId(table)

        operandColumn = @getColumnForField(structure, table, foreignColumnId, field)

        unless @getSubtype(field.subtype)
          throw "Unable to convert column; unsupported aggregate operation (#{field.subtype})"

        originalColumn = super structure, table, field
        resultingColumn = utils.copy originalColumn
        angular.extend(resultingColumn.properties,
          operand_column_id: operandColumn.id
          derivative_type: @definition
          aggregate_operation: field.subtype
          joins: [
              local_column_ids: [localColumnId]
              foreign_column_ids: [foreignColumnId]
          ]
        )

        if @nonDataTypeChange(originalColumn, resultingColumn)
          return resultingColumn

        # If we're counting, counting distinct, or using exists, set the data
        # type and old data type to something reasonable.
        # Otherwise, assume that the type of the aggregate column is the same
        # as the type of the operation column.
        if field.subtype in ['count', 'count_distinct', 'exists']
          resultingColumn.data_type =
            type: "int"
          # If we're editing an existing column and it already has an
          # integer data type, keep it, otherwise try INT.
          #
          # This will throw an error if the old_data_type was not an
          # int, but that's the right thing to do because we don't
          # allow changing column data types.

          # Unless we're editing an existing column, default to 'INT'
          # (same as the admin panel)
          unless resultingColumn.id?
            resultingColumn.old_data_type = 'INT'
          else
            unless resultingColumn.old_data_type in ['INT', 'BIGINT']
              resultingColumn.old_data_type = 'INT' # Will trigger a
                                                    # datatype change
                                                    # error. This is
                                                    # intentional.
          resultingColumn.field_type = 'value_general'
        else
          resultingColumn.data_type = operandColumn.data_type
          resultingColumn.old_data_type = operandColumn.old_data_type
          resultingColumn.field_type = if operandColumn.field_type? then operandColumn.field_type else 'value_general'

        return resultingColumn

      @validateReference: (localTableId, field, reference) ->
        reference.from.table is field.attrs.ref.table and reference.to.table is localTableId

      @getSupportedRestrictionTableIds = (localTableId, field) ->
        if field.attrs?.ref?.table?
          [field.attrs.ref.table]
        else
          []

      @getFilterSetProperties: (localTableId, field) ->
        properties =
          tableIds: @getSupportedRestrictionTableIds(localTableId, field)
          referenceToLocalTable: true

        if properties.tableIds.length is 0
          properties.warning =
            title: "Filters for this column type depend on the operation column"
            message: "Select an operation table to add filters and view filter sets."

        return properties

  ]
)
